import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoodSmile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 10l.01 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 10l.01 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9.5 15a3.5 3.5 0 0 0 5 0" })
	]
});
export default SvgMoodSmile;
